export const getAvatarText = (name: string): string => {
  const words = name.split(' ').filter((word) => word.trim() !== '');
  if (words.length > 1) {
    return (words[0][0] + words[1][0]).toUpperCase();
  }
  return words[0].slice(0, 2).toUpperCase();
};
